import './yangilik.css';
import { topbar } from "../components/topbar";
import image from '../../images/news.jpg';

const news = [
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
    {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'}
];

const news_nav = news.map((data) =>
    <nav className='new-body'>
        <nav className='new-time'>
            <em>Yangilik |</em> 19.12.2022 <i className='fa fa-eye'> 65</i>
        </nav>
        <nav className='news-img'>
            <img src={data.image} alt="rasm" />
        </nav>
        <p className='new-text'>{data.body}</p>
    </nav>
);

export default function Yangilik(){
    return(
        <div className="yangiliklar">
            {topbar('Bo`lim yangilik va e`lonlari', 'xodim')}
            <div className="content news-content">
                {news_nav}
            </div>
        </div>
    )
}